import toast from 'react-hot-toast';

type ToastType = 'default' | 'success' | 'error';

export function showToast(message: string, type: ToastType = 'default'): void {
  if (type === 'success') {
    toast.success(message);
  } else if (type === 'error') {
    toast.error(message);
  } else {
    toast(message);
  }
}
